import {useRef, useState} from "react";
import styled from "styled-components";
import theme from "../../style/theme";
import {useClickOutside} from "../../utils/click/handle-click";

interface Props {
    value: string;
    selectTitle: string;
    active?: boolean;
    onClick?: (value: string) => void;
    leftBorderRadius?: boolean;
    rightBorderRadius?: boolean;
    width?: string;
}

export const SwitchButton: React.FC<Props> = (
    {
        value,
        selectTitle,
        active,
        onClick,
        leftBorderRadius,
        rightBorderRadius,
        width,
    }
) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const handleClickBox = () => {
        onClick?.(value);
        setOpen(!open);
    };

    useClickOutside(ref, () => setOpen(false));

    const getBorderRadius = () => {
        if (leftBorderRadius && rightBorderRadius) {
            return "4px";
        }

        if (leftBorderRadius) {
            return "4px 0 0 4px";
        }

        if (rightBorderRadius) {
            return "0 4px 4px 0";
        }

        return "4px";
    };

    const borderRadius = getBorderRadius();

    return (
        <div ref={ref}>
            <SelectedItem
                value={value}
                onClick={handleClickBox}
                style={{
                    background:
                        open || active
                            ? `${theme.palette.primitives.yellow50}`
                            : "transparent",
                    border:
                        open || active
                            ? `1px solid ${theme.palette.primitives.yellow400}`
                            : "1px solid #bec3cb",
                }}
                borderRadius={borderRadius}
                active={active}
                width={width}
            >
                {selectTitle}
            </SelectedItem>
        </div>
    );
};

interface SelectedItemProps {
    value: string;
    borderRadius: string;
    active?: boolean;
    width?: string;
}

const SelectedItem = styled.div<SelectedItemProps>`
  width: ${(props) => (props.width ? props.width : "11.6rem")};
  padding: 0.75rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: ${(props) => props.borderRadius};
  justify-content: center;
  border: ${(props) =>
          props.value ? "1px solid #FCCA00" : "1px solid #bec3cb"};
  background-color: ${(props) => (props.value ? "#FFFCF2" : "#ffffff")};

  &:hover {
    background-color: #f5f6f9;
  }

  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: ${theme.palette.primitives.gray700};
`;
